



















import Vue from "vue";

export default Vue.extend({
  props: {
    image: {
      type: String,
      required: false,
    },
    altText: {
      type: String,
      required: false,
      default: "",
    },
    text: {
      type: String,
      required: false,
    },
    tile: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: "m",
      validator(value) {
        return ["l", "m", "s"].includes(value);
      },
    },
    color: {
      type: String,
      required: false,
      default: "secondary lighten-4",
    },
  },
  computed: {
    initials(): string {
      return (this.text?.match(/\b(\w)/g) || []).join("").substring(0, 2);
    },
    pixelSize(): number {
      switch (this.size) {
        case "s":
          return 28;
        case "m":
          return 40;
        case "l":
          return 84;
        default:
          return 40;
      }
    },
    textSize(): string {
      if (this.size == "s") {
        return "font-size-xs";
      }
      if (this.size == "l") {
        return "font-size-xl";
      }
      return "";
    },
  },
});
